export enum Urls {
  PATTERN = '/pattern',
  CREATE_COMPLAINT = '/create-complaint',
  GENERATE_PDF = '/claim',
}
